import type { MenuRowDef } from '@/components/app/editor/context-menus/menu-action-rows'
import type { ObjectActionRowId } from '../types/object-action-row-id'
import type { ObjectMenuActionId } from '../types/object-menu-action-id'

/**
 * The arrange, group, clipboard and lock/freeze rows that end both the object and the photo menu.
 * They stay clickable without a handler (the click only closes the menu), except Delete (greyed
 * out) and Ungroup (hidden). Lock/Unlock and Freeze/Unfreeze swap via each action's `hidden`.
 */
export const OBJECT_ACTION_ROWS: ReadonlyArray<MenuRowDef<ObjectActionRowId>> = [
  { id: 'bringToFront', label: 'Bring to Front', shortcutKey: 'bringToFront' },
  { id: 'bringForward', label: 'Bring forward', shortcutKey: 'bringForward' },
  { id: 'sendBackward', label: 'Send backward', shortcutKey: 'sendBackward' },
  { id: 'sendToBack', label: 'Send to Back', shortcutKey: 'sendToBack' },
  { id: 'groupObjects', label: 'Group', shortcutKey: 'group' },
  { id: 'ungroupObjects', label: 'Ungroup', shortcutKey: 'ungroup', whenNoHandler: 'hidden' },
  'separator',
  { id: 'cut', label: 'Cut', shortcutKey: 'cut' },
  { id: 'copy', label: 'Copy', shortcutKey: 'copy' },
  { id: 'duplicate', label: 'Duplicate', shortcutKey: 'duplicate' },
  { id: 'paste', label: 'Paste', shortcutKey: 'paste' },
  { id: 'pasteInPlace', label: 'Paste in place', shortcutKey: 'pasteInPlace' },
  { id: 'delete', label: 'Delete', shortcutKey: 'delete', whenNoHandler: 'disabled' },
  'separator',
  { id: 'unlockSelected', label: 'Unlock Selected', shortcutKey: 'unlock', hiddenByDefault: true },
  { id: 'lockSelected', label: 'Lock Selected', shortcutKey: 'lock' },
  {
    id: 'unfreezeSelected',
    label: 'Unfreeze Selected',
    shortcutKey: 'toggleFreeze',
    hiddenByDefault: true,
  },
  { id: 'freezeSelected', label: 'Freeze Selected', shortcutKey: 'toggleFreeze' },
  { id: 'unlockAll', label: 'Unlock All' },
  { id: 'unfreezeAll', label: 'Unfreeze All' },
]

/** Edit Path and Text on Path: greyed out while their handler is missing. */
export const PATH_COMMAND_ROWS: ReadonlyArray<MenuRowDef<ObjectMenuActionId>> = [
  { id: 'editPath', label: 'Edit Path', whenNoHandler: 'disabled' },
  { id: 'textOnPath', label: 'Text on Path', whenNoHandler: 'disabled' },
]

export const EDIT_TEXT_ROW: ReadonlyArray<MenuRowDef<ObjectMenuActionId>> = [
  { id: 'editText', label: 'Edit Text' },
]

export const CHECK_SPELLING_ROW: ReadonlyArray<MenuRowDef<ObjectMenuActionId>> = [
  { id: 'checkSpelling', label: 'Check Spelling' },
]

export const CONVERT_TEXT_TO_SHAPE_ROW: ReadonlyArray<MenuRowDef<ObjectMenuActionId>> = [
  { id: 'convertTextToShape', label: 'Convert text to shape' },
]
